import { AddAndEditPerimeterCoordinatesForm } from '@/schemas/perimeter-coordinates-schema'

export function validateCoordinatesMinutes(value: string): boolean {
  const minutes = parseFloat(value)

  return minutes >= 0 && minutes <= 59
}

export function validateCoordinatesSeconds(value: string): boolean {
  const seconds = parseFloat(value)

  return seconds >= 0 && seconds <= 59.9999999
}

export function validateCoordinatesDegrees(value: string): boolean {
  if (!value) return false

  const degrees = parseFloat(value)

  return degrees >= 0 && degrees <= 85
}

export function validateDecimalLatitudeCoordinates(value: string): boolean {
  const lat = parseFloat(value)

  return lat >= -85 && lat <= 85
}

export function validateDecimaLongitudeAndLongitudeDegrees(
  value: string,
): boolean {
  const lng = parseFloat(value)

  return lng >= -180 && lng <= 180
}

export function perimeterCoordinatesGreaterThanOneAndLessThanThree(
  data: AddAndEditPerimeterCoordinatesForm,
) {
  const {
    type,
    decimal_coordinates: decimalCoordinates,
    polar_coordinates: polarCoordinates,
  } = data.coordinates

  if (type === 'Polar') {
    return (
      polarCoordinates &&
      polarCoordinates.length !== 0 &&
      polarCoordinates.length < 3
    )
  }
  return (
    decimalCoordinates &&
    decimalCoordinates.length !== 0 &&
    decimalCoordinates.length < 3
  )
}
